import { Component, OnInit } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'boi-cookies-policy',
  templateUrl: './cookies-policy.component.html'
})
export class CookiesPolicyComponent implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;

  constructor(private readonly headerService: HeaderService) {}

  ngOnInit(): void {
    this.headerService.setHeaderTitle('');
  }
}
